var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.isFormValid,
                    callback: function($$v) {
                      _vm.isFormValid = $$v
                    },
                    expression: "isFormValid"
                  }
                },
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "Información General" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  label: _vm.formFields.activo.label,
                                  color: "success",
                                  "persistent-hint": "",
                                  hint: _vm.mensajeEstado,
                                  readonly: _vm.disabled,
                                  "data-testid": _vm.testId + "--estado"
                                },
                                model: {
                                  value: _vm.formFields.activo.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.activo,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.activo.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md6: "" } },
                            [
                              _c("v-select", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: !_vm.disabled && "required",
                                    expression: "!disabled && 'required'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.proveedorGps.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.proveedorGps.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.proveedorGps.id,
                                  "data-testid": _vm.testId + "--proveedor-gps",
                                  items: _vm.formFields.proveedorGps.items,
                                  disabled: _vm.disabled || _vm.edicion,
                                  "item-text": "nombre",
                                  "item-value": "id",
                                  "no-data-text": "Datos no disponibles"
                                },
                                model: {
                                  value: _vm.formFields.proveedorGps.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.proveedorGps,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.proveedorGps.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md6: "" } },
                            [
                              _c("v-select", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: !_vm.disabled && "required",
                                    expression: "!disabled && 'required'"
                                  }
                                ],
                                attrs: {
                                  label:
                                    _vm.formFields.clienteProveedorGps.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.clienteProveedorGps.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.clienteProveedorGps.id,
                                  "data-testid":
                                    _vm.testId + "--cliente-proveedor-gps",
                                  items:
                                    _vm.formFields.clienteProveedorGps.items,
                                  disabled: _vm.disabled || _vm.edicion,
                                  "item-text": "nombre",
                                  "item-value": "id",
                                  "no-data-text": "Datos no disponibles"
                                },
                                model: {
                                  value:
                                    _vm.formFields.clienteProveedorGps.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.clienteProveedorGps,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.clienteProveedorGps.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "Credenciales Conexión" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value:
                                      !_vm.disabled &&
                                      "required|max:50|loginUnico",
                                    expression:
                                      "!disabled && 'required|max:50|loginUnico'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.usuario.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.usuario.id
                                  ),
                                  "data-vv-name": _vm.formFields.usuario.id,
                                  "data-testid": _vm.testId + "--usuario",
                                  counter: 50,
                                  disabled: _vm.disabled
                                },
                                model: {
                                  value: _vm.formFields.usuario.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.usuario,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.usuario.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md6: "" } },
                            [
                              _c("CampoContrasena", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: !_vm.disabled && "required|max:50",
                                    expression: "!disabled && 'required|max:50'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.password.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.password.id
                                  ),
                                  "data-vv-name": _vm.formFields.password.id,
                                  "test-id": _vm.testId + "--contrasena",
                                  counter: 50,
                                  disabled: _vm.disabled
                                },
                                model: {
                                  value: _vm.formFields.password.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.password,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.password.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "FormFieldsContainer",
                        [
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md6: "" } },
                            [
                              _c("DatePicker", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: !_vm.disabled && "required",
                                    expression: "!disabled && 'required'"
                                  }
                                ],
                                ref: "fechaInicio",
                                attrs: {
                                  label: _vm.formFields.fechaInicio.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.fechaInicio.id
                                  ),
                                  id: _vm.formFields.fechaInicio.id,
                                  "test-id": _vm.testId + "--fecha-inicio",
                                  disabled: _vm.disabled,
                                  min: _vm.fechaMinima
                                },
                                model: {
                                  value: _vm.formFields.fechaInicio.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.fechaInicio,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.fechaInicio.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md6: "" } },
                            [
                              _c("DatePicker", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value:
                                      !_vm.disabled &&
                                      "fechaTerminoMayor:fechaInicio",
                                    expression:
                                      "!disabled && 'fechaTerminoMayor:fechaInicio'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.fechaTermino.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.fechaTermino.id
                                  ),
                                  id: _vm.formFields.fechaTermino.id,
                                  "test-id": _vm.testId + "--fecha-termino",
                                  disabled: _vm.disabled,
                                  min: _vm.fechaMinima
                                },
                                model: {
                                  value: _vm.formFields.fechaTermino.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.fechaTermino,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.fechaTermino.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value:
                                      !_vm.disabled && "required|min_value:1",
                                    expression:
                                      "!disabled && 'required|min_value:1'"
                                  }
                                ],
                                attrs: {
                                  label:
                                    _vm.formFields.intervaloTransmiciones.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.intervaloTransmiciones.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.intervaloTransmiciones.id,
                                  "data-testid":
                                    _vm.testId + "--intervalo-transmiciones",
                                  disabled: _vm.disabled,
                                  type: "number"
                                },
                                model: {
                                  value:
                                    _vm.formFields.intervaloTransmiciones.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.intervaloTransmiciones,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.intervaloTransmiciones.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value:
                                      !_vm.disabled && "required|min_value:1",
                                    expression:
                                      "!disabled && 'required|min_value:1'"
                                  }
                                ],
                                attrs: {
                                  label:
                                    _vm.formFields.cantidadActividadesPorBloque
                                      .label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.cantidadActividadesPorBloque
                                      .id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.cantidadActividadesPorBloque
                                      .id,
                                  "data-testid":
                                    _vm.testId + "--cantidadActividadesBloque",
                                  disabled: _vm.disabled,
                                  type: "number"
                                },
                                model: {
                                  value:
                                    _vm.formFields.cantidadActividadesPorBloque
                                      .value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields
                                        .cantidadActividadesPorBloque,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.cantidadActividadesPorBloque.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }